/**************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2024 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/

// used for the custom payload triggers

export default (ref, targetSelector, value, webComponent, params = {}) => {
    // Reference to the DOM root element required to send events
    const entityType = params.entityType;
    const prop = params.prop;
    const operation = params.operation;
    if (!ref || !targetSelector || !entityType || !prop || !operation) {
        return;
    }
    let target;

    // If component is embedded in web component, consider the web component as root
    let root = ref?.current?.closest(webComponent);
    if (!root) {
        // Otherwise use reference directly
        root = ref?.current;
    }

    // Add target element to list of receivers
    let parent = root?.parentElement;
    if (parent) {
        target = parent.querySelector(targetSelector);
    }

    const payloadData = {
        entityType,
        prop,
        operation,
        params,
        value
    };

    const createEvent = (name, payloadData) => {
        return new CustomEvent(name, {
            detail: {
                data: payloadData
            }
        });
    };

    if (target) {
        target.dispatchEvent(createEvent('cif:trigger-event', payloadData));
    }
};
